import { useCallback } from "react";

import { useDateFnsLocale } from "Hooks/useDateFnsLocale";
import { format as dateFnsFormat } from "date-fns";

export const useFormatLocale = () => {
  const locale = useDateFnsLocale();

  return useCallback(
    (date: number | Date, format = "PP") =>
      dateFnsFormat(date, format, { locale }),
    [locale],
  );
};
